import React from "react"
import { useRouter } from "next/router"

import { SignInButton, SignUpButton } from "@clerk/nextjs"
import { Button } from "@coval/ui"

export const NotLoggedIn: React.FC = () => {
  const router = useRouter()
  const currentPath = router.asPath

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      Hmmm, it looks like you're not logged in. Please sign in or sign up to
      access this page
      <div className="h-4" />
      <SignUpButton forceRedirectUrl={currentPath}>
        <Button>Sign Up</Button>
      </SignUpButton>
      <div className="h-4" />
      <SignInButton forceRedirectUrl={currentPath}>
        <Button>Sign In</Button>
      </SignInButton>
    </div>
  )
}
